import { render, staticRenderFns } from "./framework_notification.vue?vue&type=template&id=5708f438&"
import script from "./framework_notification.vue?vue&type=script&lang=js&"
export * from "./framework_notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports